<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import TypographyItem from '@/components/Typography/TypographyItem.vue'
import UserDetailView from '@/components/User/UserDetailView.vue'
import { type UserModel } from '@/types/models/UserModel'
import type { PermissionsEnums } from '@/types/permissions/PermissionsEnum'
import { DATETIME_FORMAT } from '@/utils/dateUtils'
import moment from 'moment'

type Props = {
    data: UserModel
    submitted: boolean
    editPermission?: PermissionsEnums
    maxItemPerRow?: number
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'click'): void
    (e: 'change', value: Partial<UserModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <UserDetailView
            :data="data"
            :submitted="submitted"
            :label="$t('common.saveModifications')"
            :editPermission="editPermission"
            :maxItemPerRow="maxItemPerRow"
            :loading="loading"
            @click="$emit('click')"
            @update="$emit('change', $event)">
            <slot />
            <template #update>
                <slot name="update" />
            </template>
        </UserDetailView>
        <StackLayout direction="column" :gap="8">
            <TypographyItem
                v-if="data.validation_date"
                :label="`${$t('user.detail.validationDate')}: ${moment(data.validation_date).format(
                    DATETIME_FORMAT
                )}`"
                class="align-self-end" />
            <TypographyItem
                v-else
                :label="$t('user.detail.notValidatedYet')"
                class="align-self-end" />
            <slot name="metadata" />
        </StackLayout>
    </StackLayout>
</template>
